<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <RegistroCompraAdmin></RegistroCompraAdmin>
</v-col>
</v-row>
</v-container>
</div>
</template>

<script>
import RegistroCompraAdmin from '@/components/tienda/compra/RegistroCompraAdmin.vue';

export default {
  data() {
    return {}
  },
  components: {
    RegistroCompraAdmin
  },
  methods: {}
}
</script>
